/**
 * WordPress dependencies
 */
export * from '@wordpress/components';

export {
	__experimentalGrid as Grid,
	__experimentalHeading as Heading,
	__experimentalItemGroup as ItemGroup,
	__experimentalInputControl as InputControl,
	__experimentalInputControlPrefixWrapper as InputControlPrefixWrapper,
	__experimentalToggleGroupControlOption as ToggleGroupControlOption,
	__experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
	__experimentalUnitControl as UnitControl,
	__experimentalNumberControl as NumberControl,
	__experimentalToolsPanel as ToolsPanel,
	__experimentalToolsPanelItem as ToolsPanelItem,
	__experimentalHStack as HStack,
	__experimentalZStack as ZStack,
	__experimentalVStack as VStack,
	__experimentalDropdownContentWrapper as DropdownContentWrapper,
	__experimentalSpacer as Spacer,
	__experimentalTruncate as Truncate,
	__experimentalParseQuantityAndUnitFromRawValue as parseQuantityAndUnitFromRawValue,
	__experimentalUseCustomUnits as useCustomUnits,
	__experimentalHasSplitBorders as hasSplitBorders,
	__experimentalIsDefinedBorder as isDefinedBorder,
	__experimentalText as Text,
	__experimentalView as View,
} from '@wordpress/components';

export type { BaseControlProps } from '@wordpress/components/build-types/base-control/types';
export type { BoxControlValue } from '@wordpress/components/build-types/box-control/types';
export type { ButtonAsButtonProps } from '@wordpress/components/build-types/button/types';
export type {
	ColorObject,
	PaletteObject,
} from '@wordpress/components/build-types/color-palette/types';
export type { ControlledRangeValue } from '@wordpress/components/build-types/range-control/types';
export type { DropdownProps } from '@wordpress/components/build-types/dropdown/types';
export type { GradientPickerComponentProps } from '@wordpress/components/build-types/gradient-picker/types';
export type { HeadingSize } from '@wordpress/components/build-types/heading/types';
export type { ItemGroupProps } from '@wordpress/components/build-types/item-group/types';
export type { PopoverProps } from '@wordpress/components/build-types/popover/types';
export type { Size } from '@wordpress/components/build-types/input-control/types';
export type { ToggleGroupControlProps } from '@wordpress/components/build-types/toggle-group-control/types';
export type {
	UnitControlProps,
	UnitControlOnChangeCallback,
} from '@wordpress/components/build-types/unit-control/types';
export type { WordPressComponentProps } from '@wordpress/components/build-types/context';
export type { WPUnitControlUnit } from '@wordpress/components/build-types/unit-control/types';

import {
	// eslint-disable-next-line
	__experimentalToggleGroupControl as OriginalToggleGroupControl,
	BaseControl as OriginalBaseControl,
	CheckboxControl as OriginalCheckboxControl,
	FormTokenField as OriginalFormTokenField,
	RangeControl as OriginalRangeControl,
	SelectControl as OriginalSelectControl,
	TextControl as OriginalTextControl,
	TextareaControl as OriginalTextareaControl,
	ToggleControl as OriginalToggleControl,
} from '@wordpress/components';

// @ts-expect-error Compiler complains, but this is just a temporary fix.
const WrappedBaseControl: typeof OriginalBaseControl = ( props ) => (
	<OriginalBaseControl
		{ ...{
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const BaseControl = Object.assign(
	WrappedBaseControl,
	OriginalBaseControl
);

const WrappedCheckboxControl: typeof OriginalCheckboxControl = ( props ) => (
	<OriginalCheckboxControl
		{ ...{
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const CheckboxControl = Object.assign(
	WrappedCheckboxControl,
	OriginalCheckboxControl
);

const WrappedFormTokenField: typeof OriginalFormTokenField = ( props ) => (
	<OriginalFormTokenField
		{ ...{
			__next40pxDefaultSize: true,
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const FormTokenField = Object.assign(
	WrappedFormTokenField,
	OriginalFormTokenField
);

// @ts-expect-error Compiler complains, but this is just a temporary fix.
const WrappedRangeControl: typeof OriginalRangeControl = ( props ) => (
	<OriginalRangeControl
		{ ...{
			__next40pxDefaultSize: true,
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const RangeControl = Object.assign(
	WrappedRangeControl,
	OriginalRangeControl
);

export const SelectControl: typeof OriginalSelectControl = ( props ) => (
	<OriginalSelectControl
		{ ...{
			__next40pxDefaultSize: true,
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);

// @ts-expect-error Compiler complains, but this is just a temporary fix.
const WrappedTextControl: typeof OriginalTextControl = ( props ) => (
	<OriginalTextControl
		{ ...{
			__next40pxDefaultSize: true,
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const TextControl = Object.assign(
	WrappedTextControl,
	OriginalTextControl
);

// @ts-expect-error Compiler complains, but this is just a temporary fix.
const WrappedTextareaControl: typeof OriginalTextareaControl = ( props ) => (
	<OriginalTextareaControl
		{ ...{
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const TextareaControl = Object.assign(
	WrappedTextareaControl,
	OriginalTextareaControl
);

// @ts-expect-error Compiler complains, but this is just a temporary fix.
const WrappedToggleControl: typeof OriginalToggleControl = ( props ) => (
	<OriginalToggleControl
		{ ...{
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const ToggleControl = Object.assign(
	WrappedToggleControl,
	OriginalToggleControl
);

const WrappedToggleGroupControl: typeof OriginalToggleGroupControl = (
	// @ts-expect-error Compiler complains, but this is just a temporary fix.
	props
) => (
	<OriginalToggleGroupControl
		{ ...{
			__next40pxDefaultSize: true,
			__nextHasNoMarginBottom: true,
			...props,
		} }
	/>
);
export const ToggleGroupControl = Object.assign(
	WrappedToggleGroupControl,
	OriginalToggleGroupControl
);
